/* src/app/quickbooks/access-granted/access-granted.component.scss */
/*# sourceMappingURL=access-granted.component.css.map */
